import {
  ORANGE, TEAL, VERT, formatPrix, TourneeBar,
  initials, colorFor, producersOf, cheapestOffer,
} from './catalogue-utils'
import { useTheme } from '../../theme'

// Fiche produit du module Paniers (client) — fidele prototype v5 (ScreenProduit) :
// gros visuel + stepper quantite + liste des producteurs derriere le produit
// (attribution auto au meilleur prix, multi-offres).

export default function ProduitScreen({
  glass, tc, ts,
  tour, produit, cart, formatDate, onBack, onGoPanier,
}) {
  const { isWeb3 } = useTheme()
  if (!produit) return null

  const off = cheapestOffer(produit)
  const out = !off
  const producers = producersOf(produit)
  const qty = off ? (cart.cartFor(tour.id)[off.tourOfferId] || 0) : 0
  const stockRestant = (produit.offres || []).reduce((s, o) => s + Number(o.quantiteRestante || 0), 0)
  const emoji = produit.product?.category?.emoji || '🧺'
  const unit = off?.unit || produit.product?.unit || ''

  const dec = () => off && cart.add(tour.id, off.tourOfferId, -1)
  const inc = () => off && cart.add(tour.id, off.tourOfferId, 1)

  return (
    <>
      <TourneeBar tour={tour} formatDate={formatDate} />

      <button onClick={onBack} className={`text-[13px] font-semibold mb-2.5 ${ts}`}>← Rayons</button>

      {/* Carte produit */}
      <div className={`rounded-[28px] px-5 py-6 text-center ${glass}`} style={{ animation: 'popIn .35s ease both' }}>
        <div className="text-[80px]" style={out ? { filter: 'grayscale(1)' } : { filter: 'drop-shadow(0 14px 22px rgba(7,62,61,0.22))' }}>{emoji}</div>
        <h1 className={`font-serif text-[27px] mt-2 ${tc}`}>{produit.product?.nom || 'Produit'}</h1>
        <p className={`text-[13px] ${ts}`}>{unit}{!out ? ` · stock tournée : ${stockRestant}` : ''}</p>
        {out ? (
          <p className="text-[15px] font-bold mt-2" style={{ color: ORANGE }}>Épuisé pour cette tournée</p>
        ) : (
          <>
            <p className={`text-[25px] font-bold mt-2 ${tc}`}>{formatPrix(produit.prixMin ?? off.prix)}</p>
            <div className="flex justify-center items-center gap-4 mt-3.5">
              <button onClick={dec} className={`w-11 h-11 rounded-2xl text-[20px] font-bold ${glass} ${tc}`}>−</button>
              <span className={`text-[20px] font-bold min-w-[28px] ${tc}`}>{qty}</span>
              <button onClick={inc} className="w-11 h-11 rounded-2xl text-[20px] font-bold" style={{ background: ORANGE, color: VERT, boxShadow: '0 10px 22px rgba(244,137,83,0.35)' }}>+</button>
            </div>
            <button
              onClick={onGoPanier}
              disabled={!qty}
              className="mt-4 w-full py-3.5 rounded-full text-[14.5px] font-bold text-creme"
              style={{ background: qty ? VERT : 'rgba(7,62,61,0.18)' }}
            >
              Voir le panier
            </button>
          </>
        )}
      </div>

      {/* Producteurs derriere le produit */}
      {producers.length > 0 && (
        <div className={`rounded-[22px] p-4 mt-3.5 ${glass}`} style={{ animation: 'riseIn .4s .1s ease both' }}>
          <p className="text-[10.5px] font-bold uppercase tracking-[0.18em]" style={{ color: TEAL }}>
            {producers.length > 1 ? `${producers.length} producteurs derrière ce produit` : 'Le producteur derrière ce produit'}
          </p>
          <div className="flex flex-col gap-2.5 mt-3">
            {producers.map((pr) => (
              <div key={pr.id || pr.nom} className="flex items-center gap-3 px-3 py-2.5 rounded-2xl" style={{ background: 'rgba(255,255,255,0.45)', border: '1px solid rgba(255,255,255,0.8)' }}>
                <span className="w-[38px] h-[38px] rounded-full flex-shrink-0 flex items-center justify-center text-sm font-extrabold text-creme" style={{ background: colorFor(pr.id || pr.nom), border: '2px solid rgba(255,255,255,0.95)', boxShadow: '0 4px 10px rgba(7,62,61,0.2)' }}>
                  {initials(pr.nom)}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="text-[13.5px] font-bold" style={{ color: VERT }}>{pr.nom}</p>
                  <p className="text-[11px]" style={{ color: 'rgba(7,62,61,0.5)' }}>Producteur local</p>
                </div>
                <span className="text-[12px]" style={{ color: 'rgba(7,62,61,0.4)' }}>›</span>
              </div>
            ))}
          </div>
          <p className="text-[11px] mt-2.5 leading-relaxed" style={{ color: 'rgba(7,62,61,0.5)' }}>
            {producers.length > 1
              ? 'Votre commande est attribuée automatiquement au meilleur prix pour cette tournée. Bientôt : choisissez votre producteur.'
              : 'Prix fixé par le producteur, commission Manrina affichée au récapitulatif.'}
          </p>
        </div>
      )}
    </>
  )
}
